import React from "react";
import { useNavigate } from "react-router-dom";
import "./Card.css";

const Card = ({ src, alt, title, description, imageLink, buttons, navigateToSection }) => {
  const navigate = useNavigate(); // React Router's navigation hook

  const handleButtonClick = (button) => {
    if (!button || !button.link) return;

    const { link } = button;

    // Handle internal navigation
    if (link.startsWith("section-") && navigateToSection) {
      navigateToSection(link);
    } 
    // Handle external route navigation
    else if (link.startsWith("http")) {
      window.open(link, "_blank"); // Open external links in a new tab
    } 
    // Handle internal route navigation
    else {
      navigate(link);
    }
  };

  const renderButtons = () => {
    if (!buttons || !Array.isArray(buttons)) return null;

    return buttons.map((button, index) => {
      const { text, type = "button" } = button;

      if (type === "link") {
        // Render as a link
        return (
          <a key={index} href={button.link} className="card-button" target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        );
      }

      // Render as a button with navigation logic
      return (
        <button key={index} className="card-button" onClick={() => handleButtonClick(button)}>
          {text}
        </button>
      );
    });
  };

  return (
    <div className="card">
      {src && (
        imageLink ? (
          <a href={imageLink} target="_blank" rel="noopener noreferrer">
            <img src={src} alt={alt || "Card image"} className="card-image" />
          </a>
        ) : (
          <img src={src} alt={alt || "Card image"} className="card-image" />
        )
      )}
      <div className="card-content">
        <h3>{title}</h3>
        <p>{description}</p>
        <div className="card-buttons" style={{ display: "flex", gap: "10px", flexWrap: "wrap", justifyContent: "center", marginTop: "10px" }}>{renderButtons()}</div>
      </div>
    </div>
  );
};

export default Card;
